import { routerApp, analyticsUrl, enableOnPremise } from '../../app.module';
import { httpRequestGenerator } from '../../services/utilities';

routerApp.factory('TakeawaysService', ['$http', function($http) {
    var requestFunc = httpRequestGenerator(enableOnPremise, $http);

    return {
        getTakeaways: function(vesselId) {
            var url = analyticsUrl + vesselId + "/tresTakeaways";
            return requestFunc({
                    url: url,
                    method: "GET"
            });
        },
        postTakeaway: function(vesselId, obj) {
            var url = analyticsUrl + vesselId + "/tresTakeaways";
            return requestFunc({
                    url: url,
                    method: "POST",
                    data: obj
            });
        }
    }

}]);